import { render, staticRenderFns } from "./groupCalendarAFSDetail.vue?vue&type=template&id=77447d25"
import script from "./groupCalendarAFSDetail.vue?vue&type=script&lang=js"
export * from "./groupCalendarAFSDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports